 const FILTER_TYPE_MIN_MAX = "MinMaxSelect";



const budgetMinList = [
    {
        "label": "0",
        "value": "0"
    },
    {
        "label": "10000",
        "value": "10000"
    },
    {
        "label": "20000",
        "value": "20000"
    }
]

const budgetMaxList =[
    {
        "label": "10000",
        "value": "10000"
    },
    {
        "label": "20000",
        "value": "20000"
    },
    {
        "label": "25000",
        "value": "25000"
    }
]

const minrating =[
    {
        "label": "1",
        "value": "1"
    },
    {
        "label": "2",
        "value": "2"
    },
    {
        "label": "3",
        "value": "3"
    },
    {
        "label": "4",
        "value": "4"
    },
    {
        "label": "5",
        "value": "5"
    }
]

const maxrating = [
    {
        "label": "1",
        "value": "1"
    },
    {
        "label": "2",
        "value": "2"
    },
    {
        "label": "3",
        "value": "3"
    },
    {
        "label": "4",
        "value": "4"
    },
    {
        "label": "5",
        "value": "5"
    }
]

const minreviewCount = [
    {
        "label": "1",
        "value": "1"
    },
    {
        "label": "10",
        "value": "10"
    },
    {
        "label": "20",
        "value": "20"
    },
    {
        "label": "30",
        "value": "30"
    }
]

const maxreviewCount = [
    {
        "label": "10",
        "value": "10"
    },
    {
        "label": "20",
        "value": "20"
    },
    {
        "label": "30",
        "value": "30"
    },
    {
        "label": "40",
        "value": "40"
    }
]

const maxExperience = [
    {
        "label": "2",
        "value": "2"
    },
    {
        "label": "3",
        "value": "3"
    },
    {
        "label": "4",
        "value": "4"
    },
    {
        "label": "5",
        "value": "5"
    },
    {
        "label": "6",
        "value": "6"
    }
]

const minExperience = [
    {
        "label": "1",
        "value": "1"
    },
    {
        "label": "2",
        "value": "2"
    },
    {
        "label": "3",
        "value": "3"
    },
    {
        "label": "4",
        "value": "4"
    },
    {
        "label": "5",
        "value": "5"
    }
]



export const makeUpPageFilters = [
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "budget",
        "displayName": "Budget",
        "queryParamName": "budget",
        "_id": "5c1241e9caa9a513e691c6f3",
        "params": [],
        "minParams": budgetMinList,
        "maxParams": budgetMaxList,
        "minQueryParamName": "min_price",
        "maxQueryParamName": "max_price"
    },
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "reviews",
        "displayName": "Review Count",
        "queryParamName": "",
        "_id": "5c1241e9caa9a513e691c6f4",
        "params": [],
        "minParams": minreviewCount,
        "maxParams": maxreviewCount,
        "minQueryParamName": "min_reviews",
        "maxQueryParamName": "max_reviews"
    },
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "rating",
        "displayName": "Rating",
        "queryParamName": "",
        "_id": "5c1241e9caa9a513e691c6f5",
        "params": [],
        "minParams": minrating,
        "maxParams": maxrating,
        "minQueryParamName": "min_rating",
        "maxQueryParamName": "max_rating"
    },
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "experience",
        "displayName": "Years Of Experience",
        "queryParamName": "",
        "_id": "5c1241e9caa9a513e691c6f6",
        "params": [],
        "minParams": minExperience,
        "maxParams":  maxExperience,
        "minQueryParamName": "min_experience",
        "maxQueryParamName": "max_experience"
    }
]
